import React from 'react';
import PageTextContents from '../components/Widgets/PageTextContents';
import Grid from '@material-ui/core/Grid';
import {Alert} from '@material-ui/lab';


const withLayout = (WrappedComponent) => {
  return class extends React.PureComponent {
    render() {
      return (
        <div className="pda-with-layout-body-wrapper">
          <Grid container>
            <Grid item xs={8}>
              <PageTextContents
                pageTitle={this.props.title}
                pageDescription={this.props.description}
              />
            </Grid>
            <Grid item xs={12}>
              { this.props.info ? <Alert variant="filled" severity="info">{this.props.info}</Alert> : null }
            </Grid>
            <Grid item xs={12}>
              <WrappedComponent {...this.props}/>
            </Grid>
          </Grid>
        </div>

      )
    }
  }
}

export default withLayout;
